module.exports = __webpack_public_path__ + "static/media/change_time.61b8cfcf.svg";